import { ActionIcon, Container, Divider, Group, Text } from '@mantine/core';
import { IconBrandLinkedin, IconBrandX } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { localePath } from '#marketing/lib/marketing-locale.js';
import { useMarketingLocale } from '#marketing/lib/use-marketing-locale.js';

const CURRENT_YEAR = new Date().getFullYear();

/**
 * Footer for the public marketing site.
 */
export function MarketingFooter() {
  const { t } = useTranslation('common');
  const locale = useMarketingLocale();

  return (
    <Container size="lg" mt={'md'}>
      <Divider />
      <Group justify="center" align="center" py="lg" wrap="wrap" gap="md">
        <Text size="sm">{t('common.footer.copyright', { year: CURRENT_YEAR })}</Text>
        <Text size="sm">
          <Link to={localePath(locale, '/about')}>{t('marketing.footer.about')}</Link>
        </Text>
        <Text size="sm">
          <Link to={localePath(locale, '/guides')}>{t('marketing.footer.guides')}</Link>
        </Text>
        <Text size="sm">
          <Link to={localePath(locale, '/faq')}>{t('marketing.footer.faq')}</Link>
        </Text>
        <Text size="sm">
          <Link to={localePath(locale, '/privacy')}>{t('marketing.footer.privacyPolicy')}</Link>
        </Text>
        <Group gap="xs" wrap="nowrap">
          <Link
            to="https://x.com/pachub_hq"
            target="_blank"
            aria-label={t('common.footer.followX')}
            style={{ lineHeight: 0 }}
          >
            <ActionIcon size="xl" color="dark" variant="subtle" aria-label={t('common.footer.followX')}>
              <IconBrandX size={18} stroke={2} />
            </ActionIcon>
          </Link>
          <Link
            to="https://www.linkedin.com/company/pachub"
            target="_blank"
            aria-label={t('common.footer.followLinkedIn')}
            style={{ lineHeight: 0 }}
          >
            <ActionIcon size="xl" color="dark" variant="subtle" aria-label={t('common.footer.followLinkedIn')}>
              <IconBrandLinkedin size={18} stroke={2} />
            </ActionIcon>
          </Link>
        </Group>
      </Group>
    </Container>
  );
}
